import { useState } from "react";
import { registerTeacher } from "../api/auth";
import { ApiError } from "../api/client";
import { LoginBrandingPanel } from "../components/auth/LoginBrandingPanel";
import { CreateAccountFormPanel } from "../components/auth/CreateAccountFormPanel";
import {
  evaluatePasswordRequirements,
  passwordMeetsRequirements,
} from "../utils/auth/evaluatePasswordRequirements";

export function CreateAccountPage({ onLogin, onAccountCreated }) {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function handleSubmit(event) {
    event.preventDefault();
    setError(null);

    const requirements = evaluatePasswordRequirements(password);
    if (!passwordMeetsRequirements(requirements)) {
      setError("Please meet all password requirements before continuing.");
      return;
    }

    setIsSubmitting(true);
    try {
      const result = await registerTeacher({
        firstName: firstName.trim(),
        lastName: lastName.trim(),
        email: email.trim(),
        password,
      });
      onAccountCreated?.({
        firstName: firstName.trim(),
        lastName: lastName.trim(),
        email: email.trim(),
        session: result,
      });
    } catch (err) {
      const message =
        err instanceof ApiError
          ? err.message
          : err instanceof Error
            ? err.message
            : "Could not create your account. Please try again.";
      setError(message);
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div className="flex min-h-screen bg-white">
      <LoginBrandingPanel />
      <CreateAccountFormPanel
        firstName={firstName}
        lastName={lastName}
        email={email}
        password={password}
        error={error}
        isSubmitting={isSubmitting}
        onFirstNameChange={(event) => setFirstName(event.target.value)}
        onLastNameChange={(event) => setLastName(event.target.value)}
        onEmailChange={(event) => setEmail(event.target.value)}
        onPasswordChange={(event) => setPassword(event.target.value)}
        onSubmit={handleSubmit}
        onLogin={onLogin}
      />
    </div>
  );
}
